import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M4.2417 8.5C2.86099 8.5 1.7417 7.38071 1.7417 6C1.7417 4.77577 2.62166 3.75706 3.78358 3.54188C3.99876 2.37996 5.01747 1.5 6.2417 1.5C7.46593 1.5 8.48464 2.37996 8.69982 3.54188C9.86174 3.75706 10.7417 4.77577 10.7417 6C10.7417 7.38071 9.62241 8.5 8.2417 8.5M4.7417 10L6.2417 11.5M6.2417 11.5L7.7417 10M6.2417 11.5V5.5" />
  </svg>
);
